import React, { useState } from 'react';
import { LocationIcon, EmailIcon, PhoneIcon, WhatsAppIcon, HeartIcon, ShareIcon, CheckIcon } from '../Icons/Icons';
import './PropertyHeader.css';

function PropertyHeader({ property }) {
  const [isSaved, setIsSaved] = useState(false);

  const handleContact = (type) => {
    console.log(`Contact via ${type}`);
  };

  return (
    <div className="property-header">
      <div className="property-header-main">
        <div className="property-title-section">
          <div className="property-badges">
            {property.featured && (
              <span className="badge badge-featured">Featured</span>
            )}
            {property.verified && (
              <span className="badge badge-verified">
                <CheckIcon size={14} color="white" />
                <span>Verified</span>
              </span>
            )}
            {property.purpose && (
              <span className="badge badge-purpose">For {property.purpose}</span>
            )}
          </div>

          <h1 className="property-title">{property.title}</h1>

          <div className="property-location-header">
            <LocationIcon size={18} color="var(--color-text-secondary)" />
            <span className="location-text">{property.location}</span>
          </div>
        </div>

        <div className="property-price-section">
          <div className="price-main">{property.price}</div>
          {property.pricePerSqft && (
            <div className="price-per-sqft">{property.pricePerSqft}</div>
          )}
        </div>
      </div>

      <div className="property-header-actions">
        <button className="action-btn btn-contact" onClick={() => handleContact('form')}>
          <EmailIcon size={18} />
          <span>Contact Agent</span>
        </button>

        <button className="action-btn btn-call" onClick={() => handleContact('call')}>
          <PhoneIcon size={18} />
          <span>Call</span>
        </button>

        <button className="action-btn btn-whatsapp" onClick={() => handleContact('whatsapp')}>
          <WhatsAppIcon size={18} />
          <span>WhatsApp</span>
        </button>

        <button
          className={`action-btn btn-save ${isSaved ? 'saved' : ''}`}
          onClick={() => setIsSaved(!isSaved)}
        >
          <HeartIcon size={18} filled={isSaved} color={isSaved ? '#e74c3c' : 'currentColor'} />
          <span>{isSaved ? 'Saved' : 'Save'}</span>
        </button>

        <button className="action-btn btn-share" onClick={() => handleContact('share')}>
          <ShareIcon size={18} />
          <span>Share</span>
        </button>
      </div>
    </div>
  );
}

export default PropertyHeader;
